
import React, { useState, startTransition } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { ThemeToggle } from '@/components/theme/ThemeToggle';

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    startTransition(() => {
      setMobileMenuOpen(!mobileMenuOpen);
    });
  };

  return (
    <header className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-6xl mx-auto px-4">
      <nav className="bg-card/80 backdrop-blur-md border border-border rounded-2xl px-6 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" x="0" y="0" version="1.1" viewBox="0 0 471.9 123.4" className="h-8 w-auto fill-foreground">
                <path d="M296.1 26.6c-3.1.2-6.2 0-9.5 0v-10c3.2-1.2 5.5-4.4 5.5-8 0-4.7-3.8-8.6-8.6-8.6-4.7 0-8.6 3.8-8.6 8.6 0 3.7 2.4 6.9 5.7 8.1v10h-15.4c-6.9.1-13.5 1.5-19.3 5.5-10.9 7.6-13.6 18.4-13.4 31 .4 19.9 12.9 32.9 32.7 33 12.3.1 24.6.2 37-.1 4.3-.1 8.7-.8 12.7-2.2 11.9-4.2 18.9-15.7 19.8-28.5 1.7-26.7-14.5-40.7-38.6-38.8zm25 39.9c-.8 9.1-7 14.8-16.2 14.8h-21.5c-7.3 0-14.7.1-22 0-8-.1-13.8-5.2-15.2-13.1-.2-1.3-.3-2.6-.4-4-1.1-15.4 4.3-23.9 22.4-23.1 12 .6 24 .1 36 .1 10.4.1 16.8 6.3 17.1 16.7 0 3 0 5.8-.2 8.6zm-22.8 35.9c-5.3 2.4-9.9 4.4-14.4 6.4-.3.1-.6.1-.8 0-4.6-2.1-9.2-4.1-14.4-6.4-.7-.3-1.4.2-1.4.9v19.1c0 .7.8 1.2 1.4.9 5.3-2.3 9.9-4.4 14.5-6.4.3-.1.6-.1.8 0 4.7 2.1 9.2 4.1 14.4 6.4.7.3 1.4-.2 1.4-.9v-19.1c-.1-.8-.8-1.2-1.5-.9z"/>
                <path d="M300.8 54.8c-1.8 0-3.4.7-4.7 1.9l-.3.3c-1.1 1.2-1.7 2.8-1.7 4.5 0 3.7 3 6.7 6.7 6.7s6.7-3 6.7-6.7-3-6.7-6.7-6.7z"/>
                <circle cx="266.2" cy="61.5" r="6.7"/>
                <path d="M68.2 29.5h15.4v65.1H68.4l-.8-9.6c-3.7 7.7-13.9 11.4-21.1 11.5C27.3 96.7 13 84.8 13 61.9c0-22.4 14.9-34.2 33.9-34.1 8.7 0 17 4.1 20.7 10.6l.6-8.9zM29.1 61.9c0 12.4 8.6 19.8 19.3 19.8 25.3 0 25.3-39.5 0-39.5-10.7.1-19.3 7.3-19.3 19.7zM91 44.6v28.1c0 16.2 9.2 24.3 23.4 23.8 2.7-.1 5-.3 7.4-.9v-15c-2 .8-4.3 1.3-6.3 1.3-5.1-.1-8.5-3.1-8.5-9.3V44.5h13.3V30.6h-13.2V13.9H91v30.7zm93.9-15.3 14.3 49 14.9-49h17.8l-22.7 65.5h-18.7l-6.7-19.3-5.8-21.8-5.8 21.8-6.7 19.3h-18.7L124 29.3h18l14.9 49 14.1-49h13.9zm175 .2 1.2 7.5c5-8.1 11.7-9.2 18.3-9.2 6.7 0 13.2 2.6 16.8 6.2L389 48c-3.3-2.8-6.3-4.2-11.6-4.2-8.4 0-16.2 4.5-16.2 16.5v34.3H345V29.5h14.9zM418 2.3v53.3l21.9-26.1h19.3v.9l-26.5 29.7 30.2 33.3v1.2h-19.4L418 65.1v29.4h-16.1V2.3H418z"/>
              </svg>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/features" className="text-yellow-400 font-medium hover:text-yellow-300 transition-colors">
              Features
            </Link>
            <Link to="/pricing" className="text-muted-foreground hover:text-foreground transition-colors">
              Pricing
            </Link>
            <Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors">
              About us
            </Link>
            <Link to="/login" className="text-muted-foreground hover:text-foreground transition-colors">
              Login
            </Link>
            <ThemeToggle />
            <Link 
              to="/register" 
              className="bg-yellow-400 text-neutral-900 px-5 py-1.5 rounded-full font-semibold hover:bg-yellow-300 transition-colors"
            >
              Sign up
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              type="button"
              className="text-foreground p-2"
              onClick={toggleMobileMenu}
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pt-4 border-t border-border">
            <div className="flex flex-col space-y-4">
              <Link to="/features" className="text-yellow-400 font-medium">Features</Link>
              <Link to="/pricing" className="text-muted-foreground">Pricing</Link>
              <Link to="/about" className="text-muted-foreground">About us</Link>
              <Link to="/login" className="text-muted-foreground">Login</Link>
              <div className="flex justify-start">
                <ThemeToggle />
              </div>
              <Link to="/register" className="bg-yellow-400 text-neutral-900 px-5 py-1.5 rounded-full font-semibold text-center">
                Sign up
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
